import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ee2d0d56"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  "wire:loading": "",
  class: "jr-absolute jr-top-0 jr-left-0 jr-right-0 jr-bottom-0 jr-w-full jr-h-full jr-overflow-hidden jr-bg-white jr-flex jr-flex-col jr-items-center jr-justify-center"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "jr-loader jr-ease-linear jr-rounded-full jr-border-4 jr-border-t-4 jr-border-gray-200 jr-h-12 jr-w-12 jr-mb-4" }, null, -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}